import React from "react";

const About = () => {
  return (
    <section id="narrative" className="pt-16">
      <div className="rounded-lg border border-slate-200 bg-white/70 p-6 shadow-sm">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-sky-600">
          Career Narrative
        </p>
        <h2 className="mt-2 text-2xl font-bold text-slate-950">
          I bridge customer needs and technical execution.
        </h2>
        <p className="mt-4 text-base leading-7 text-slate-600">
          My career started close to customers: onboarding, support,
          implementation, and the uncomfortable production questions that need
          calm answers. I then moved deeper into software and cloud engineering,
          which changed how I work: I do not just pass issues along, I try to
          understand the product, reproduce the problem, read the code, and give
          engineering teams something useful.
        </p>
        <p className="mt-4 text-base leading-7 text-slate-600">
          That is why solution engineering fits me. I like turning vague
          enterprise requirements into a practical design, a working POC, a demo,
          or a clear next step that both the customer and the engineers can
          trust.
        </p>
      </div>
    </section>
  );
};

export default About;
